<template>
  <v-container grid-list-xl mt-4>
    <v-layout align-center justify-center column>
      <v-flex xs12>
        <v-card max-width="800">
          <v-card-title primary-title class="pb-0">
            <h3
              class="title mb-0 text-uppercase blue-grey--text text--darken-3"
            >
              Cities
            </h3>
          </v-card-title>
          <v-card-actions>
            <v-container grid-list-sm>
              <v-layout row wrap>
                <v-flex v-for="city in cities" :key="city.title">
                  <v-btn :to="city.path" flat>
                    {{ city.title | capitalize }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card max-width="800">
          <v-card-title primary-title class="pb-0">
            <h3
              class="title mb-0 text-uppercase blue-grey--text text--darken-3"
            >
              Communities
            </h3>
          </v-card-title>
          <v-card-actions>
            <v-container grid-list-sm>
              <v-layout justify-start row wrap>
                <v-flex v-for="community in communities" :key="community.title">
                  <v-btn :to="community.path" flat>
                    {{ community.title | capitalize }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card max-width="800">
          <v-card-title primary-title class="pb-0">
            <h3
              class="title mb-0 text-uppercase blue-grey--text text--darken-3"
            >
              Zip Codes
            </h3>
          </v-card-title>
          <v-card-actions>
            <v-container grid-list-sm>
              <v-layout row wrap>
                <v-flex v-for="zipcode in zipcodes" :key="zipcode.title">
                  <v-btn :to="zipcode.path" flat>
                    {{ zipcode.title | capitalize }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { communities, zipcodes, cities } from '../json/links.json';

export default {
  name: 'SearchLinks',
  data() {
    return {
      communities,
      zipcodes,
      cities,
    };
  },
};
</script>
